import type { CSSProperties, ReactNode } from 'react';
import { useState } from 'react';

export interface CardProps {
  children: ReactNode;
  pad?: boolean;
  hoverable?: boolean;
  accent?: boolean;
  onClick?: () => void;
  style?: CSSProperties;
}

export function Card({
  children,
  pad = true,
  hoverable = false,
  accent = false,
  onClick,
  style,
}: CardProps) {
  const [hovered, setHovered] = useState(false);
  const elevated = hoverable && hovered;
  return (
    <div
      onClick={onClick}
      onMouseEnter={hoverable ? () => setHovered(true) : undefined}
      onMouseLeave={hoverable ? () => setHovered(false) : undefined}
      style={{
        background: accent ? 'var(--apm-card-2)' : 'var(--apm-card)',
        border: `1px solid ${elevated ? 'var(--apm-line-2)' : 'var(--apm-line)'}`,
        borderRadius: 'var(--apm-radius-lg)',
        padding: pad ? 'var(--apm-card-pad)' : 0,
        boxShadow: elevated ? 'var(--apm-shadow-md)' : 'var(--apm-shadow-sm)',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'border-color .12s, box-shadow .12s, transform .12s',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
